export default "__VITE_ASSET__fb97a5ff__"